import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ThemeProvider from './theme/ThemeProvider';
import AuthProvider from './auth/AuthProvider';
import RequireAuth from './auth/RequireAuth';
import Layout from './components/Layout';
import Home from './pages/Home';
import CaseView from './pages/CaseView';
import CaseQueue from './pages/CaseQueue';
import Reports from './pages/Reports';
import Documents from './pages/Documents';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Logout from './pages/Logout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <CssBaseline />
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/logout" element={<Logout />} />

              {/* Protected routes */}
              <Route
                path="/*"
                element={
                  <RequireAuth>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/cases" element={<CaseQueue />} />
                        <Route path="/cases/:caseNumber" element={<CaseView />} />
                        <Route path="/documents" element={<Documents />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/settings" element={<div>Settings Page (TBD)</div>} />
                        <Route
                          path="/admin"
                          element={
                            <RequireAuth requiredRole="Admin">
                              <Admin />
                            </RequireAuth>
                          }
                        />
                        <Route path="/help" element={<div>Help Page (TBD)</div>} />
                        <Route path="/manage-users" element={<div>Manage Users Page (TBD)</div>} />
                      </Routes>
                    </Layout>
                  </RequireAuth>
                }
              />
            </Routes>
          </Router>
        </ThemeProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
};

export default App;
